module.exports = __webpack_public_path__ + "img/image_home_logo.f0887709.png";